import BackPageButton from "components/buttons/BackPageButton";
import { Outlet, useSearchParams } from "react-router-dom";
import qs from "qs";
import { useMemo } from "react";
import ROUTES from "constants/routes";
import {
  useCandidateHeaderQuery,
  useCompetencyMapHeaderQuery,
  useExaminationTitleQuery,
  useVacancyHeaderQuery,
} from "@generated/graphql";
import { getTestingPath } from "helpers/index";

const ExaminationLayout = () => {
  const [searchParams] = useSearchParams();
  const params = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);
  const { vacancyId, candidateId, examinationId, competencyMapId, competencyMapsList } = params as {
    vacancyId?: string;
    candidateId?: string;
    examinationId?: string;
    competencyMapId?: string;
    competencyMapsList?: boolean;
  };

  const { data: vacancyHeaderData } = useVacancyHeaderQuery({ variables: { vacancyId: vacancyId! }, skip: !vacancyId });
  const vacancy = vacancyHeaderData?.vacancy;

  const { data: candidateHeaderData } = useCandidateHeaderQuery({
    variables: { candidateId: candidateId! },
    skip: !candidateId,
  });
  const candidate = candidateHeaderData?.companyCandidate;

  const { data: examinationHeaderData } = useExaminationTitleQuery({
    variables: { examinationId: examinationId! },
    skip: !examinationId,
  });
  const examination = examinationHeaderData?.examination;

  const { data: competencyMapHeaderData } = useCompetencyMapHeaderQuery({
    variables: { competencyMapId: competencyMapId! },
    skip: !competencyMapId,
  });
  const competencyMap = competencyMapHeaderData?.competencyMap;

  const getBackPageButtonProps = () => {
    if (vacancyId) {
      return {
        text: `Вакансия «${vacancy?.title}»`,
        link: `/${ROUTES.VACANCIES}/view/${vacancyId}`,
      };
    }
    if (candidateId) {
      return {
        text: `Кандидат ${candidate?.fullName}`,
        link: `/${ROUTES.CANDIDATE}/view/${candidateId}`,
      };
    }
    if (examinationId) {
      return {
        text: `Тестирование «${examination?.title}»`,
        link: getTestingPath("examination", examinationId),
      };
    }
    if (competencyMapId) {
      return {
        text: `Карта компетенций «${competencyMap?.title}»`,
        link: `/${ROUTES.COMPETENCE_MAPS}/view/${competencyMapId}`,
      };
    }
    if (competencyMapsList) {
      return {
        text: `Список карт компетенций`,
        link: `/${ROUTES.COMPETENCE_MAPS}`,
      };
    }

    return {
      text: `Список тестирований`,
      link: `/${ROUTES.TESTING}`,
    };
  };

  return (
    <>
      <BackPageButton {...getBackPageButtonProps()} />
      <Outlet />
    </>
  );
};

export default ExaminationLayout;
